import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import i18n from 'i18next';
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import Loader from 'react-loader-spinner';
import Drawer from 'react-modern-drawer';
import { useDispatch } from 'react-redux';
import Sticky from 'react-sticky-el';
import 'react-modern-drawer/dist/index.css';

import {
  resetFilters,
  setSort,
  setItemsPerPage,
} from '../../../modules/companyFilter/companyFilterActions';
import { eventGA } from '../../../utils/GA';
import { getCompanyRoute } from '../../../utils/helpers/routesBuilder';
import { DisplayFlexS } from '../../../utils/stylesHelpers';
import filterIcon from '../../assets/imgs/icons/filterIcon.svg';
import loadMoreIcon from '../../assets/imgs/icons/loadMoreIcon.svg';
import { actionGA, categoryGA } from '../../constants/googleAnalytics';
import { companySorts } from '../../constants/sorts';
import { LinkS, SelectNew, Text } from '../common';

import {
  CloseButtonS,
  CloseIconWrapper,
  CompaniesFilterBlockS,
  CompaniesFilterMobileS,
  CompaniesFilterWrapS,
  CompaniesItemsWrapS,
  CompaniesListButtonFilterS,
  CompaniesListButtonIconS,
  CompaniesListButtonSortS,
  CompanyItemsWrapMobile,
  CustomizeDriver,
  DrawerContentHeaderS,
  DrawerContentS,
  DrawerFiltersWraperS,
  LoaderWrap,
  MobileCompaniesWrapS,
  MobileInfiniteLoad,
  MobileInfiniteLoadAction,
  NoCompaniesFoundS,
  TextDeleteFilter,
} from './CompaniesListS';
import CompanyCard from './companyCard';
import CompaniesFilters from './filters/companiesFilters';

export const NoCompaniesFound = () => (
  <NoCompaniesFoundS className="sm-display-none">
    <Text size="bigText" color="violet">
      {i18n.t('companies.noCompaniesNoFoundByQuery.firstPart')}
    </Text>
    <Text size="bigText" color="violet" weight="bold">
      {i18n.t('companies.noCompaniesNoFoundByQuery.secondPart')}
    </Text>
  </NoCompaniesFoundS>
);

export const LoaderSection = ({ sizeLoader }) => (
  <Sticky>
    <DisplayFlexS justify="center">
      <LoaderWrap size={sizeLoader}>
        <Loader type="ThreeDots" color="#1d1d6c" height={80} width={80} />
      </LoaderWrap>
    </DisplayFlexS>
  </Sticky>
);

const FilterDrawer = ({ isFiltersDrawerOpen, setIsFiltersDrawerOpen, dispatch }) => (
  <Drawer
    open={isFiltersDrawerOpen}
    onClose={() => setIsFiltersDrawerOpen(false)}
    direction="bottom"
    className="filters-drawer"
  >
    <DrawerContentS>
      <DrawerContentHeaderS>
        <span
          onClick={() => {
            dispatch(resetFilters());
            setIsFiltersDrawerOpen(false);
          }}
        >
          {i18n.t('companies.filter.clearFilterBtnMobile')}
        </span>
        <h3>{i18n.t('companies.filter.drawerFilterTitle')}</h3>
        <CloseButtonS onClick={() => setIsFiltersDrawerOpen(false)} />
      </DrawerContentHeaderS>
      <DrawerFiltersWraperS>
        <CompaniesFilters submitFiltersButton={true} onSubmitFilters={() => setIsFiltersDrawerOpen(false)} />
      </DrawerFiltersWraperS>
    </DrawerContentS>
  </Drawer>
);

const CompaniesListMobile = ({
  countPerPage,
  sort,
  shouldReturnAllCompaniesForKanton,
  isCompaniesFetching,
  sizeLoader,
  companies,
  amount,
  refLoader,
}) => {
  const [isFiltersDrawerOpen, setIsFiltersDrawerOpen] = useState(false);  
  const dispatch = useDispatch();

  return (
    <MobileCompaniesWrapS>
      <DisplayFlexS justify="space-between" className="heading-text">
        <Text style={{ fontSize: '13px' }} fontFamily="bold">
          <Trans i18nKey="companies.topCapture" />
        </Text>
      </DisplayFlexS>

      <CustomizeDriver />
      {shouldReturnAllCompaniesForKanton && <NoCompaniesFound />}

      <CompaniesFilterBlockS />
      <CompaniesFilterMobileS>
        <CompaniesListButtonFilterS onClick={() => setIsFiltersDrawerOpen(true)}>
          <Trans i18nKey="companies.filter.capture" />
          <CompaniesListButtonIconS src={filterIcon} />
        </CompaniesListButtonFilterS>
        <CompaniesListButtonSortS>
          <SelectNew height="auto" values={companySorts} value={sort}>
            {companySorts &&
              Object.values(companySorts).map(({ value, transPath }) => (
                <option
                  key={value}
                  value={value}
                  onClick={({ target }) => dispatch(setSort(target.value))}
                >
                  {i18n.t(transPath)}
                </option>
              ))}
          </SelectNew>
        </CompaniesListButtonSortS>
      </CompaniesFilterMobileS>
      <DisplayFlexS>
        <CompaniesFilterWrapS>
          <DisplayFlexS
            justify="space-between"
            style={{ padding: '0 5px', marginBottom: 20 }}
            className="sm-display-none"
          >
            <DisplayFlexS justify="space-between" style={{ height: 36 }}>
              <Text size="bigText">
                <Trans i18nKey="companies.filter.capture" />
              </Text>
              <TextDeleteFilter onClick={() => dispatch(resetFilters())}>
                <Trans i18nKey="companies.filter.clearFilterBtn" />
                <CloseIconWrapper>
                  <FontAwesomeIcon icon="times" />
                </CloseIconWrapper>
              </TextDeleteFilter>
            </DisplayFlexS>
          </DisplayFlexS>
          <CompaniesFilters />
        </CompaniesFilterWrapS>

        <CompaniesItemsWrapS ref={refLoader}>
          <CompanyItemsWrapMobile>
            {isCompaniesFetching && <LoaderSection sizeLoader={sizeLoader} />}
            {companies.map((c) => (
              <LinkS
                to={getCompanyRoute(c._id, c.name)}
                key={c._id}
                onClick={() =>
                  eventGA({
                    category: categoryGA.COMPANY_LIST_PAGE,
                    action: actionGA.COMPANIES,
                    label: c.name,
                  })
                }
              >
                <CompanyCard {...c} push={push} />
              </LinkS>
            ))}
            <MobileInfiniteLoad>
              <span>{`${companies.length} Firmenprofil aus ${amount} werden vorgestellt`}</span>
              {amount > countPerPage && (
                <MobileInfiniteLoadAction>
                  <img src={loadMoreIcon} alt="load more companies" />
                  <Text onClick={() => dispatch(setItemsPerPage(countPerPage + 25))}>
                    {i18n.t('companies.loadMoreCompaniesMobile')}
                  </Text>
                </MobileInfiniteLoadAction>
              )}
            </MobileInfiniteLoad>
          </CompanyItemsWrapMobile>
        </CompaniesItemsWrapS>
        <FilterDrawer
          isFiltersDrawerOpen={isFiltersDrawerOpen}
          setIsFiltersDrawerOpen={setIsFiltersDrawerOpen}
          companies={companies}
          dispatch={dispatch}
        />
      </DisplayFlexS>
    </MobileCompaniesWrapS>
  );
};

export default CompaniesListMobile;
